import './Input.scss'
import classNames from 'classnames'
import React, { type ChangeEventHandler, type FocusEventHandler } from 'react'

interface Props {
  value?: string | number | File | null
  type?: 'text' | 'password' | 'number' | 'file' | 'color'
  accept?: string
  onChange: ChangeEventHandler
  name: string
  label?: string
  className?: string
  required?: boolean
  readOnly?: boolean
  disabled?: boolean
  placeholder?: string
  error?: boolean | string | undefined
  onBlur?: FocusEventHandler
  style?: React.CSSProperties
}

export default function Input ({
  value,
  type = 'text',
  accept,
  onChange,
  onBlur,
  name,
  label,
  className = '',
  readOnly = false,
  disabled = false,
  placeholder = '',
  error,
  style = {}
}: Props): React.ReactElement {
  const isFileType = type === 'file'

  return (
    <div className={`Input ${className}`} style={style}>
      {label && <div className="Input__label fw-bold mb-2">{label}</div>}

      <div className="d-flex">
        <div className="flex-grow-1">
          <input
            value={isFileType ? undefined : (value as string | number)}
            onChange={onChange}
            type={type}
            accept={accept}
            className={classNames('Input__input w-100', {
              'Input__input--error': error
            })}
            name={name}
            disabled={disabled}
            onBlur={onBlur}
            readOnly={readOnly}
            placeholder={placeholder}
          />
        </div>
      </div>

      {error && <div className="Input__error text-end">{error}</div>}
    </div>
  )
}
